import useSWR from 'swr'
import { referralsApi } from '../api'
import { referralsKeys } from './referrals.keys'

export function useReferrals() {
  const { data, error, isLoading, mutate } = useSWR(referralsKeys.list, async () => {
    const result = await referralsApi.getReferrals()
    if (!result.success) throw new Error(result.error ?? 'Unknown error')
    return result.data!
  })

  return {
    payload: data ?? null,
    isLoading,
    error: error?.message ?? null,
    mutate,
  }
}
